import { LinkId } from '../../../../common/AnalyticsContext/LinkId';
import { DrawerFilterPill } from '../../FilterPill/DrawerFilterPill';
import { MoreFiltersDrawer } from './MoreFiltersDrawer/MoreFiltersDrawer';
import { useAppliedFilterCount, useClearFilters } from './MoreFiltersHelpers';

export const MoreFilters = () => {
  const onClear = useClearFilters();

  const appliedFilterCount = useAppliedFilterCount();

  return (
    <DrawerFilterPill
      appliedFilterCount={appliedFilterCount}
      filterIcon
      hasValue={appliedFilterCount > 0}
      onClear={onClear}
      caption="More"
      trackingId={LinkId.FILTER_BY_MORE_FILTERS}
      content={<MoreFiltersDrawer />}
    />
  );
};
